import { inject, Pipe, PipeTransform } from '@angular/core';
import { appendToRmaStaticImageUrl } from '@rma/generic/ng/util';

@Pipe({
  name: 'staticImageUrl',
  standalone: true,
})
export class StaticImageUrlPipe implements PipeTransform {
  private readonly rmaStaticImageUrl = inject(appendToRmaStaticImageUrl);

  transform(value: string): string {
    const relativePath = value?.replace(/^\//, '');
    return this.rmaStaticImageUrl(relativePath);
  }
}
